export default import.meta.ROLLUP_FILE_URL_t9bm9x69A6cY9JayquP0dg